import { DefaultModal } from '../../components/Modals/DefaultModal'
import { EncounterView } from './EncounterView'

// Read-only EncounterView hosted in a modal. EncounterView renders its own header (with a close
// button) and footer, so the modal's own chrome is collapsed (overlayHeader + noCloseButton) and
// the body is made a full-height flex column for the view to fill.
export const EncounterViewModal = ({
  examId,
  patientId,
  onClose,
}: {
  examId: string
  patientId: string
  onClose: () => void
}) => (
  <DefaultModal
    isOpen
    onClose={onClose}
    size="4xl"
    overlayHeader
    noCloseButton
    contentProps={{ h: '85vh', maxH: '85vh' }}
    bodyProps={{ display: 'flex', flexDirection: 'column', minH: 0, flex: 1 }}
    render={({ onClose: close }) => (
      <EncounterView examId={examId} patientId={patientId} onClose={close} />
    )}
  />
)
